module.exports = __webpack_public_path__ + "static/img/loginImg.986e4b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/loginLuobei/img/loginImg.png
// module id = k8yV
// module chunks = 183